import axios from 'axios';
import config from '../config';

export default axios.create({
  baseURL: config.host + '/api',
  headers: { 'x-access-token': localStorage.getItem('APIToken') },
});
